import React from 'react';
import { Route, Redirect, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import gridPageStyle from '../../pages/grid-page.module.less';
import AlertsListPage from './alerts-list-page';
import style from './alerts-page.module.less';
import AlertsDetailPage from './alerts-detail-page';
import * as NavActions from '../../store/alerts/nav/alerts.nav.actions';
import * as PagingActions from '../../store/paging/paging.actions';
import { useOnComponentMount } from '../../hooks/use-on-component-mount';

const gridPagingViewName = 'alerts.shiptogether.grid';
const detailsPagingViewName = 'alerts.shiptogether.details';

const AlertsPage = () => {
  const { alertFilter, alertId } = useParams() || {};
  const dispatch = useDispatch();
  const onDetailsPage = !!alertId;

  useOnComponentMount(() => {
    dispatch(NavActions.updateOrdersPageLeftNav());
    if (onDetailsPage) {
      dispatch(PagingActions.setViewPageAndPageSize(gridPagingViewName, 1, 100));
      dispatch(PagingActions.readPagingInfoFromUrl(detailsPagingViewName));
      return;
    }
    dispatch(PagingActions.setViewPageAndPageSize(detailsPagingViewName));
    dispatch(PagingActions.readPagingInfoFromUrl(gridPagingViewName, 100));
  });

  return (
    <div className={classnames(gridPageStyle['main-content'], style['main-content'])}>
      <div
        className={classnames(style['alerts-page-wrappers'], {
          [style['detail-page-in']]: onDetailsPage,
        })}
      >
        <Route
          path='/orders/alerts/:alertFilter'
          render={() => (
            <div className={style['list-page']}>
              <AlertsListPage />
            </div>
          )}
        />
        <Route
          path='/orders/alerts/:alertFilter/:alertId'
          render={({ match }) => (
            <div className={style['detail-page']}>
              <AlertsDetailPage match={match} />
            </div>
          )}
        />
      </div>
      {!alertFilter && <Redirect exact from='/orders/alerts' strict to='/orders/alerts/shipTogether' />}
    </div>
  );
};

export default AlertsPage;
